const langAdminEmailNotifications = {
	title: {
		tag: 'admin.email_notifications.title',
		fr: 'Notifications e-mails',
		en: 'Emails notifications',
	},
	column_fund_name: {
		tag: 'admin.email_notifications.column_fund_name',
		fr: 'Nom du fonds',
		en: 'Fund name',
	},
	column_document_name: {
		tag: 'admin.email_notifications.column_document_name',
		fr: 'Nom du document',
		en: 'Document name',
	},
	column_user_email: {
		tag: 'admin.email_notifications.column_user_email',
		fr: 'E-mail',
		en: 'User email',
	},
	column_document_release_date: {
		tag: 'admin.email_notifications.column_document_release_date',
		fr: 'Date de sortie',
		en: 'Release date',
	},
	column_notification_subject: {
		tag: 'admin.email_notifications.column_notification_subject',
		fr: 'Objet',
		en: 'Subject',
	},
	column_notification_cc: {
		tag: 'admin.email_notifications.column_notification_cc',
		fr: 'Cc',
		en: 'Cc',
	},
	column_notification_send_datetime: {
		tag: 'admin.email_notifications.column_notification_send_datetime',
		fr: "Date d'envoi",
		en: 'Send date time',
	},
	column_notification_send_status: {
		tag: 'admin.email_notifications.column_notification_send_status',
		fr: 'Statut',
		en: 'Status',
	},
	filter_start_released_date: {
		tag: 'admin.email_notifications.filter_start_released_date',
		fr: 'Date de diffusion min',
		en: 'Start released date',
	},
	filter_end_released_date: {
		tag: 'admin.email_notifications.filter_end_released_date',
		fr: 'Date de diffusion max',
		en: 'End released date',
	},
	filter_keywords: {
		tag: 'admin.email_notifications.filter_keywords',
		fr: 'Nom du document',
		en: 'Document name',
	},
	filter_contact: {
		tag: 'admin.email_notifications.filter_contact',
		fr: 'Contact',
		en: 'Contact',
	},
	filter_funds: {
		tag: 'admin.email_notifications.filter_funds',
		fr: 'Fonds',
		en: 'Fund',
	},
	filter_groups: {
		tag: 'admin.email_notifications.filter_groups',
		fr: 'Groupes',
		en: 'Groups',
	},
};

export default langAdminEmailNotifications;
